import CostsModal from '@features/costs/costs';
export default CostsModal;
